import _default from './Transition';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/modules/Transition/index.js
// module id = 916
// module chunks = 0